export default __webpack_public_path__ + "static/media/logo_header.8ebc438e.jpg";